import React from "react";


const Thingy = props => {
	return <div className="hiddenClass">
		{props.children}
	</div>
}


export default Thingy;